module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"submit":"Enregistrer","submitForValidation":"Enregistrer pour validation","cancel":"Retour","infoEquipement":"Ce(s) équipement(s) est(sont)","title":"Création du formulaire Conformité","titleForm":"Conformité - Dossier N°{folderNumber}","processing":"Traitement en cours..."}}')
  delete Component.options._Ctor
}
